import React, { useState } from "react";
import ShareIcon from "@mui/icons-material/Share";

// import JS files

// import others files
import telegramIcon from "../../assets/imgs/telegram.svg";
import twitterIcon from "../../assets/imgs/twitter.svg";
import instagramIcon from "../../assets/imgs/instagram.svg";

const Share = (props) => {
  return (
    <>
      <div className="flex justify-between items-center mt-12  md:mt-16">
        <div className="flex items-center">
          <ShareIcon className="text-myblues-300" />
          <span className="mr-2 text-sm text-myblacks-200">
            به اشتراک‌گذاری
          </span>
        </div>
        <div className="flex items-center">
          <img
            className="w-6 md:w-8 mr-4 transition-all hover:scale-125 cursor-pointer"
            src={instagramIcon}
          />
          <img
            className="w-6 md:w-8 mr-4 transition-all hover:scale-125 cursor-pointer"
            src={telegramIcon}
          />
          <img
            className="w-6 md:w-8 mr-4 transition-all hover:scale-125 cursor-pointer"
            src={twitterIcon}
          />
        </div>
      </div>
    </>
  );
};

export default Share;
